import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management.sends');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

type SendTab = 'quotes' | 'guidance';

interface DispatchOffice {
    id: string;
    onboardingId: string;
    tenantId: string;
    customerName: string;
    status: string;
    contractType: string;
    contractPlanId: string;
    managerName: string;
    contact: string;
    email: string;
    recipientReady: boolean;
    missingReasons: string[];
    quoteReady: boolean;
    quoteDeliveryReady: boolean;
    supplyAmount: number;
    amount: number;
    vatIncluded: boolean;
    pricingSource: string;
}

@Component({
    selector: 'wiz-page-ip-management-sends',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management.sends/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageIpManagementSendsComponent implements OnInit, OnDestroy {
    public tab: SendTab = 'quotes';
    public offices: DispatchOffice[] = [];
    public quoteHistory: any[] = [];
    public officeSearch: string = '';
    public page: number = 1;
    public readonly pageSize: number = 10;
    public selectedOfficeIds: { [key: string]: boolean } = {};
    public quoteEditorOfficeId: string = '';
    public guidanceEditorOfficeId: string = '';
    public allSelected: boolean = false;
    public quoteMonth: string = new Date().toLocaleDateString('sv-SE').slice(0, 7);
    public quoteTitle: string = '';
    public settings: any = {
        quoteMessage: '고객님 안녕하세요? 주식회사 웅빈입니다.\n\n전월 IP관리시스템 이용료를 안내드립니다.\n\n주식회사 웅빈은 고객의 입장에서 항상 최선의 노력을 다하겠습니다. 감사합니다.',
        contactText: '문의 : 010-3244-3440\nkipo0318@naver.com',
        accountName: '주식회사 웅빈',
        bankAccount: '농협 301-0357-8444-71'
    };
    public guidanceSubject: string = '';
    public guidanceMessage: string = '';
    public guidanceFiles: File[] = [];
    public sending: boolean = false;
    public savingSettings: boolean = false;
    public uploadProgress: number = 0;
    public dispatchLoading: boolean = true;
    public dispatchError: string = '';
    private quoteRequestIds: { [key: string]: string } = {};
    private routeSubscription: Subscription = null;
    private readonly maxGuidanceFiles: number = 5;
    private readonly maxGuidanceFileSize: number = 20 * 1024 * 1024;
    private readonly maxGuidanceTotalSize: number = 40 * 1024 * 1024;
    private readonly allowedExtensions: string[] = [
        '.pdf', '.hwp', '.hwpx', '.doc', '.docx', '.xls', '.xlsx',
        '.ppt', '.pptx', '.txt', '.csv', '.zip', '.jpg', '.jpeg', '.png'
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.quoteTitle = this.monthLabel(this.quoteMonth) + ' IP 관리시스템 이용료 안내';
        this.syncTabFromLocation();
        await this.loadDispatchData();
        this.routeSubscription = this.router.events.subscribe(async (event) => {
            if (!(event instanceof NavigationEnd)) return;
            this.syncTabFromLocation();
            await this.service.render();
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    private responseData(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const status = Number(payload?.code ?? response?.status ?? 500);
        const data = payload?.data;
        if (!payload || status >= 400) {
            const message = payload?.message
                || (typeof data === 'string' ? data : data?.message)
                || response?.statusText
                || '요청을 처리하지 못했습니다.';
            throw new Error(String(message));
        }
        return data;
    }

    public async loadDispatchData() {
        this.dispatchLoading = true;
        this.dispatchError = '';
        await this.service.render();
        try {
            const data = this.responseData(await wiz.call('dispatch_data', {}, { method: 'GET' }));
            this.offices = Array.isArray(data?.offices) ? data.offices : [];
            this.selectedOfficeIds = {};
            this.offices.forEach((office) => this.selectedOfficeIds[office.id] = false);
            if (!this.offices.some((office) => office.id === this.quoteEditorOfficeId)) {
                this.quoteEditorOfficeId = '';
            }
            if (!this.offices.some((office) => office.id === this.guidanceEditorOfficeId)) {
                this.guidanceEditorOfficeId = '';
            }
            this.settings = { ...this.settings, ...(data?.settings || {}) };
            this.quoteHistory = Array.isArray(data?.quoteHistory) ? data.quoteHistory : [];
        } catch (error) {
            this.dispatchError = String(error?.message || '발송 대상 사무소를 불러오지 못했습니다.');
            await this.service.modal.error(this.dispatchError);
        } finally {
            this.dispatchLoading = false;
            await this.service.render();
        }
    }

    private syncTabFromLocation() {
        const requestedTab = new URLSearchParams(location.search).get('tab');
        this.tab = requestedTab === 'guidance' ? 'guidance' : 'quotes';
        this.page = 1;
    }

    public async setTab(tab: SendTab) {
        if (this.tab === tab || this.sending) return;
        this.tab = tab;
        this.clearSelection();
        this.quoteEditorOfficeId = '';
        this.guidanceEditorOfficeId = '';
        await this.router.navigateByUrl('/ip-management/sends?tab=' + tab);
        await this.service.render();
    }

    public get pageTitle() {
        return '견적/안내발송';
    }

    public get pageDescription() {
        return this.tab === 'quotes'
            ? '표준양식의 월 견적서를 생성해 회원사의 IP 관리 상담으로 전달합니다.'
            : '회원사별 안내사항을 작성하고 세금계산서 등 관련 서류를 첨부해 담당자 이메일로 발송합니다.';
    }

    public get filteredOffices() {
        const text = this.officeSearch.trim().toLowerCase();
        if (!text) return this.offices;
        return this.offices.filter((office) => [
            office.customerName,
            office.managerName,
            office.contact,
            office.email,
            office.contractType
        ].join(' ').toLowerCase().includes(text));
    }

    public get pageCount() {
        return Math.max(1, Math.ceil(this.filteredOffices.length / this.pageSize));
    }

    public get pageNumbers() {
        return Array.from({ length: this.pageCount }, (_, index) => index + 1);
    }

    public get paginatedOffices() {
        const start = (this.page - 1) * this.pageSize;
        return this.filteredOffices.slice(start, start + this.pageSize);
    }

    public async onOfficeSearchChange() {
        this.page = 1;
        await this.syncAllSelected();
    }

    public async goToPage(page: number) {
        this.page = Math.min(Math.max(page, 1), this.pageCount);
        await this.service.render();
    }

    public get selectedOffices() {
        return this.offices.filter((office) => this.selectedOfficeIds[office.id]);
    }

    public get selectableFilteredOffices() {
        return this.filteredOffices.filter((office) => this.canSelectOffice(office));
    }

    public get selectedCount() {
        return this.selectedOffices.length;
    }

    public get quoteEditorOffice(): DispatchOffice | null {
        return this.offices.find((office) => office.id === this.quoteEditorOfficeId) || null;
    }

    public get quotePreviewOffice(): DispatchOffice | null {
        return this.quoteEditorOffice;
    }

    public get quotePreviewCustomerName() {
        return this.quotePreviewOffice?.customerName || '회원사명';
    }

    public get quotePreviewContractType() {
        return this.quotePreviewOffice?.contractType || '계약 타입';
    }

    public get quotePreviewAmountText() {
        const office = this.quotePreviewOffice;
        if (!office) return '견적 금액';
        if (!office.quoteReady) return '확정 견적 금액 미등록';
        return this.quoteAmount(office).toLocaleString('ko-KR') + '원';
    }

    public get quotePreviewVatText() {
        const office = this.quotePreviewOffice;
        if (!office) return '부가세 포함 여부';
        return office.vatIncluded ? '포함' : '별도';
    }

    public get quotePreviewNotice() {
        const office = this.quotePreviewOffice;
        if (!office) return '회원사를 선택하면 실제 회원사 정보가 견적서에 반영됩니다.';
        if (!office.quoteReady) return office.customerName + '의 확정 견적 금액이 등록되기 전까지 금액은 미리보기에 표시되지 않습니다.';
        return '';
    }

    public get guidanceEditorOffice(): DispatchOffice | null {
        return this.offices.find((office) => office.id === this.guidanceEditorOfficeId) || null;
    }

    public get guidancePreviewOffice(): DispatchOffice | null {
        return this.guidanceEditorOffice;
    }

    public async toggleQuoteEditor(office: DispatchOffice) {
        if (!office || this.tab !== 'quotes') return;
        if (this.quoteEditorOfficeId === office.id) {
            this.quoteEditorOfficeId = '';
            await this.service.render();
            return;
        }
        await this.openQuoteEditor(office);
    }

    public async openQuoteEditor(office: DispatchOffice) {
        if (!office || this.tab !== 'quotes') return;
        this.quoteEditorOfficeId = office.id;
        await this.service.render();
        setTimeout(() => {
            document.getElementById('quote-editor')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 0);
    }

    public async toggleGuidanceEditor(office: DispatchOffice) {
        if (!office || this.tab !== 'guidance') return;
        if (this.guidanceEditorOfficeId === office.id) {
            this.guidanceEditorOfficeId = '';
            await this.service.render();
            return;
        }
        await this.openGuidanceEditor(office);
    }

    public async openGuidanceEditor(office: DispatchOffice) {
        if (!office || this.tab !== 'guidance') return;
        this.guidanceEditorOfficeId = office.id;
        await this.service.render();
        setTimeout(() => {
            document.getElementById('guidance-editor')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 0);
    }

    public async toggleAll(selected: boolean) {
        this.allSelected = selected;
        this.selectableFilteredOffices.forEach((office) => this.selectedOfficeIds[office.id] = selected);
        await this.service.render();
    }

    public async syncAllSelected() {
        this.allSelected = this.selectableFilteredOffices.length > 0
            && this.selectableFilteredOffices.every((office) => this.selectedOfficeIds[office.id]);
        await this.service.render();
    }

    public canSelectOffice(office: DispatchOffice) {
        return this.tab === 'quotes'
            ? office.quoteDeliveryReady
            : office.status !== 'TERMINATED' && office.recipientReady;
    }

    public officeUnavailableReason(office: DispatchOffice) {
        if (this.tab === 'quotes') {
            if (!office.quoteReady || Number(office.amount || 0) < 1) return '확정 견적 금액 미등록';
            if (!office.tenantId) return 'Core 회원사 연결 정보 없음';
            if (office.status !== 'ACTIVE') return 'IP 관리 이용 상태 확인 필요';
            return '';
        }
        if (office.status === 'TERMINATED') return '종료된 사무소';
        if (!office.recipientReady) return '담당자 이메일 미등록';
        return '';
    }

    public manageOfficeDispatch(office: DispatchOffice) {
        if (!office?.onboardingId) return;
        this.service.href('/ip-management/offices/' + office.onboardingId);
    }

    public quoteAmount(office: DispatchOffice) {
        return Number(office?.amount || 0);
    }

    public monthLabel(value: string) {
        const parts = String(value || '').split('-');
        if (parts.length !== 2) return value;
        return parts[0] + '년 ' + Number(parts[1]) + '월';
    }

    public formatDeliveryDateTime(value: string) {
        const date = new Date(String(value || ''));
        if (Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('sv-SE', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date).replace(',', '');
    }

    public async updateQuoteMonth() {
        this.quoteTitle = this.monthLabel(this.quoteMonth) + ' IP 관리시스템 이용료 안내';
        await this.service.render();
    }

    private officePayload() {
        return this.selectedOffices.map((office) => ({ id: office.id }));
    }

    private newQuoteRequestId() {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return Array.from(bytes)
            .map((value) => value.toString(16).padStart(2, '0'))
            .join('');
    }

    private quoteOfficePayload() {
        return this.selectedOffices.map((office) => {
            if (!this.quoteRequestIds[office.id]) {
                this.quoteRequestIds[office.id] = this.newQuoteRequestId();
            }
            return {
                id: office.id,
                deliveryRequestId: this.quoteRequestIds[office.id]
            };
        });
    }

    public get visibleQuoteHistory() {
        return this.quoteHistory.slice(0, 50);
    }

    private clearSelection() {
        this.offices.forEach((office) => this.selectedOfficeIds[office.id] = false);
        this.allSelected = false;
    }

    private async showDispatchResult(label: string, items: any[]) {
        const completed = items.filter((item) => item.status === '발송완료').length;
        const pending = items.filter((item) => item.status === '발송대기').length;
        const failed = items.length - completed - pending;
        const message = label + ' 처리 결과: 발송완료 ' + completed + '건 · 발송대기 ' + pending + '건 · 실패 ' + failed + '건';
        if (!pending && !failed) {
            await this.service.modal.success(message);
            return;
        }
        await this.service.modal.show({
            title: label + ' 처리 결과',
            message: message + (pending ? '\n메일 서버 설정 후 발송대기 건을 확인해주세요.' : ''),
            action: '확인',
            cancel: false,
            status: 'warning',
            actionBtn: 'warning'
        });
    }

    private async showQuoteDeliveryResult(items: any[]) {
        const created = items.filter((item) => item.outcome === 'created').length;
        const reused = items.filter((item) => item.outcome === 'reused').length;
        const failed = items.filter((item) => item.outcome === 'failed').length;
        if (items.length === 1 && !failed) {
            await this.service.modal.success(items[0].statusDetail || (
                reused
                    ? '이미 전달된 월 견적서입니다. 기존 전달 내역을 확인했습니다.'
                    : 'IP 관리 상담에 견적서를 전달했습니다.'
            ));
            return;
        }
        const summary = 'IP 관리 상담 전달 결과: 신규 전달 ' + created
            + '건 · 기존 전달 확인 ' + reused + '건 · 실패 ' + failed + '건';
        const failures = items
            .filter((item) => item.outcome === 'failed')
            .map((item) => item.officeName + ': ' + item.statusDetail)
            .join('\n');
        if (!failed) {
            await this.service.modal.success(summary);
            return;
        }
        await this.service.modal.show({
            title: '월 견적 전달 결과',
            message: summary + (failures ? '\n\n' + failures : ''),
            action: '확인',
            cancel: false,
            status: 'warning',
            actionBtn: 'warning'
        });
    }

    public async saveDefaultSettings() {
        if (this.savingSettings) return;
        if (!this.settings.quoteMessage.trim() || !this.settings.contactText.trim()
            || !this.settings.accountName.trim() || !this.settings.bankAccount.trim()) {
            await this.service.modal.error('기본 안내멘트, 문의처와 입금계좌 정보를 모두 입력해주세요.');
            return;
        }
        const limits: any = {quoteMessage: 4000, contactText: 1000, accountName: 200, bankAccount: 200};
        for (const key of Object.keys(limits)) {
            if (String((this.settings as any)[key] || '').trim().length > limits[key]) {
                await this.service.modal.error('안내문 4,000자, 문의 안내 1,000자, 예금주와 입금 계좌는 각 200자 이하로 입력해 주세요.');
                return;
            }
        }
        this.savingSettings = true;
        await this.service.render();
        try {
            this.settings = this.responseData(await wiz.call('save_dispatch_settings', {
                data: JSON.stringify(this.settings)
            }));
            await this.service.modal.success('견적 안내 기본값을 저장했습니다.');
        } catch (error) {
            await this.service.modal.error(String(error?.message || '기본 설정을 저장하지 못했습니다.'));
        } finally {
            this.savingSettings = false;
            await this.service.render();
        }
    }

    public async sendQuotes() {
        if (this.sending) return;
        if (this.selectedCount === 0) {
            await this.service.modal.error('견적서를 전달할 회원사를 선택해주세요.');
            return;
        }
        if (this.selectedOffices.some((office) => !office.quoteDeliveryReady)) {
            await this.service.modal.error('확정 견적 금액, Core 회원사 연결 및 IP 관리 이용 상태를 확인해 주세요.');
            return;
        }
        if (!this.quoteMonth || !this.quoteTitle.trim() || !this.settings.quoteMessage.trim()) {
            await this.service.modal.error('견적 기준월, 제목과 안내멘트를 입력해주세요.');
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '표준 견적서 전달',
            message: this.selectedCount + '개 회원사의 IP 관리 상담으로 표준 견적서 PDF를 전달합니다.',
            action: '전달',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        this.sending = true;
        await this.service.render();
        try {
            const data = this.responseData(await wiz.call('send_quotes', {
                offices: JSON.stringify(this.quoteOfficePayload()),
                month: this.quoteMonth,
                subject: this.quoteTitle.trim(),
                settings: JSON.stringify(this.settings)
            }));
            const items = data?.items || [];
            items.forEach((item) => {
                if (item?.outcome !== 'failed' && item?.officeId) {
                    delete this.quoteRequestIds[item.officeId];
                }
            });
            this.clearSelection();
            await this.showQuoteDeliveryResult(items);
            await this.loadDispatchData();
        } catch (error) {
            await this.service.modal.error(String(error?.message || '견적서를 전달하지 못했습니다.'));
        } finally {
            this.sending = false;
            await this.service.render();
        }
    }

    public async selectGuidanceFiles(event: any) {
        const files = Array.from(event?.target?.files || []) as File[];
        if (event?.target) event.target.value = '';
        const accepted: File[] = [];
        const rejected: string[] = [];
        let total = this.guidanceFiles.reduce((sum, file) => sum + file.size, 0);

        for (const file of files) {
            const dot = file.name.lastIndexOf('.');
            const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
            if (!this.allowedExtensions.includes(extension)) {
                rejected.push(file.name + ': 지원하지 않는 형식');
                continue;
            }
            if (!file.size || file.size > this.maxGuidanceFileSize) {
                rejected.push(file.name + ': 파일당 20MB 초과');
                continue;
            }
            if (this.guidanceFiles.length + accepted.length >= this.maxGuidanceFiles) {
                rejected.push(file.name + ': 최대 5개 초과');
                continue;
            }
            if (total + file.size > this.maxGuidanceTotalSize) {
                rejected.push(file.name + ': 전체 40MB 초과');
                continue;
            }
            accepted.push(file);
            total += file.size;
        }

        this.guidanceFiles = [...this.guidanceFiles, ...accepted];
        if (rejected.length) await this.service.modal.error(rejected.join('\n'));
        await this.service.render();
    }

    public async removeGuidanceFile(index: number) {
        this.guidanceFiles.splice(index, 1);
        await this.service.render();
    }

    public async sendGuidance() {
        if (this.sending) return;
        if (this.selectedCount === 0) {
            await this.service.modal.error('안내사항을 발송할 회원사를 선택해주세요.');
            return;
        }
        if (!this.guidanceSubject.trim() || !this.guidanceMessage.trim()) {
            await this.service.modal.error('안내 제목과 내용을 입력해주세요.');
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '안내사항 발송',
            message: this.selectedCount + '개 회원사 담당자 이메일로 안내사항과 첨부서류를 발송합니다.',
            action: '발송',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        this.sending = true;
        this.uploadProgress = 0;
        await this.service.render();
        try {
            const form = new FormData();
            form.append('offices', JSON.stringify(this.officePayload()));
            form.append('subject', this.guidanceSubject.trim());
            form.append('message', this.guidanceMessage.trim());
            form.append('file_count', String(this.guidanceFiles.length));
            this.guidanceFiles.forEach((file, index) => form.append('file_' + index, file));
            const response = await this.service.file.upload(
                wiz.url('send_guidance'),
                form,
                async (percent: number) => {
                    this.uploadProgress = percent;
                    await this.service.render();
                }
            );
            const data = this.responseData(response);
            const items = data?.items || [];
            this.guidanceSubject = '';
            this.guidanceMessage = '';
            this.guidanceFiles = [];
            this.clearSelection();
            await this.showDispatchResult('안내사항', items);
        } catch (error) {
            await this.service.modal.error(String(error?.message || '안내사항을 발송하지 못했습니다.'));
        } finally {
            this.sending = false;
            await this.service.render();
        }
    }

    public tabClass(tab: SendTab) {
        if (this.tab === tab) {
            return 'inline-flex h-11 items-center border-b-2 border-emerald-700 px-2 text-[12px] font-bold text-emerald-800';
        }
        return 'inline-flex h-11 items-center border-b-2 border-transparent px-2 text-[12px] font-semibold text-slate-500 hover:border-slate-300 hover:text-slate-800';
    }

    public quoteStatusClass(status: string) {
        switch (status) {
            case '발송완료': return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case '발송대기': return 'border-amber-200 bg-amber-50 text-amber-700';
            case '발송실패':
            case '실패': return 'border-red-200 bg-red-50 text-red-700';
            default: return 'border-slate-200 bg-slate-100 text-slate-600';
        }
    }

    public formatFileSize(size: number) {
        const bytes = Number(size || 0);
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
}

export default PageIpManagementSendsComponent;